import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import departmentSettingsSelectors from "../../store/department-settings/selectors";

class AddReportForType extends Component {
  static getDerivedStateFromProps(nextProps) {
    if(nextProps.oitsOptions) {
      return {
        oitGuid: nextProps.oitsOptions[0] && nextProps.oitsOptions[0].guid,
        reportForType: nextProps.match.params.forType
      }
    } else {
      return { reportForType: nextProps.match.params.forType };
    }
  }
  constructor(props) {
    super(props);
    const now = new Date();
    this.state = {
      properties: {
        observationDate: now.toISOString(),
        reports: [],
        submittedBy: now.toISOString(),
        type: 'dor',
      },
      oitGuid: this.props.oitsOptions && this.props.oitsOptions[0] && this.props.oitsOptions[0].guid,
      reportForType: this.props.match.params.forType,
    };
    this.addReport = this.addReport.bind(this);
  }


  // ----------------------
  // Computed
  // ----------------------

  get isFormDisabled() {
    return this.state.properties.reports.length === 0;
  }

  get isLoading() {
    return !this.props.oitsOptions;
  }

  get reportTypeString() {
    switch (this.props.match.params.forType) {
      case 'eop':
        return 'End of Phase';
      case 'rrt':
        return 'Request for Training';
      case 'wor':
        return 'Weekly Observation';
      default:
        return 'Daily Observation';
    }
  }

  // ----------------------
  // Methods
  // ----------------------

  addReport() {
    // TODO
  }

  handleSelect(e) {
    this.setState({
      oitGuid: e.target.value
    })
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Fragment>
        {!this.isLoading && (
          <Fragment>
            <div className="app-content-header">
              <h4 className="title">Add {this.state.reportForType} Report </h4>
            </div>
            <div className="app-content">
              <form className="form">
                <div className="form-group">
                  <label>
                    Select {this.props.oitShortLabel}
                  </label>
                  <select
                    className="form-control"
                    id="oitGuid"
                    name="oitGuid"
                    onChange={event => this.handleSelect(event)}
                    value={this.state.properties.oitGuid}
                  >
                    {this.props.oitsOptions.map(option => (
                      <option key={option.guid} value={option.guid}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                </div>
              </form>
            </div>
          </Fragment>
        )}
      </Fragment>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    oitsOptions: state.options.myOits,
    oitShortLabel: departmentSettingsSelectors.oitShortLabel(state)
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // TODO
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddReportForType);
